<script lang="ts" setup>
import { useFirebaseStorage } from "vuefire";
import { ref as FileRef, getBytes } from "firebase/storage";

import * as XLSX from "xlsx";

const props = defineProps({
  fileObject: {
    type: Object as PropType<MediaObject>,
    required: true,
  },
});

const isLoading = ref(true);
const storage = useFirebaseStorage();

const headers = ref<any[]>([]);
const body = ref<any>([]);

onMounted(async () => {
  const fileRef = FileRef(storage, props.fileObject.mediaHref);

  const arrayBuffer = await getBytes(fileRef);
  const data = new Uint8Array(arrayBuffer);
  const workbook = XLSX.read(data, { type: "array" });

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const json: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  headers.value = json[0];
  body.value = json.slice(1);

  isLoading.value = false;
});
</script>

<template>
  <div>
    <BaseLoading v-if="isLoading" />
    <table class="w-full overflow-auto">
      <thead>
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="index"
            class="text-left whitespace-nowrap border p-2"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in body" :key="rowIndex">
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            class="whitespace-nowrap border p-2"
          >
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped></style>
